module.exports = "/_next/static/images/clock-duotone-2bdbeb8d6f29dc889714984b3a5fa843.svg";